import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "hasPhiContact",
    "phiSameAsEmergency",
    "phiContactOptions",
    "phiContactDetails",
    "phiFirstName",
    "phiLastName",
    "phiPhone"
  ]

  static values = {
    hasPhiContact: Boolean,
    phiSameAsEmergency: Boolean
  }

  connect() {
    const initialHasPhiContact = this.hasPhiContactTarget.value === "true"
    this.hasPhiContactValue = initialHasPhiContact
    
    if (initialHasPhiContact) {
      this.phiContactOptionsTarget.classList.remove("hidden")
      this.phiSameAsEmergencyTarget.required = true
      
      const initialPhiSameAsEmergency = this.phiSameAsEmergencyTarget.value === "true"
      this.phiSameAsEmergencyValue = initialPhiSameAsEmergency
      
      if (initialPhiSameAsEmergency) {
        this.phiContactDetailsTarget.classList.add("hidden")
        this.clearPhiFields()
      } else if (this.phiSameAsEmergencyTarget.value === "false") {
        this.phiContactDetailsTarget.classList.remove("hidden")
        this.setRequiredFields()
      }
    } else {
      this.phiContactOptionsTarget.classList.add("hidden")
      this.phiContactDetailsTarget.classList.add("hidden")
      this.phiSameAsEmergencyTarget.required = false
      this.clearPhiFields()
    }
  }

  updateHasPhiContact() {
    const hasPhiContact = this.hasPhiContactTarget.value === "true"
    this.hasPhiContactValue = hasPhiContact

    if (hasPhiContact) {
      this.phiContactOptionsTarget.classList.remove("hidden")
      this.phiSameAsEmergencyTarget.required = true
      this.updatePhiSameAsEmergency()
    } else {
      this.phiContactOptionsTarget.classList.add("hidden")
      this.phiContactDetailsTarget.classList.add("hidden")
      this.phiSameAsEmergencyTarget.required = false
      this.clearPhiFields()
    }
  }

  updatePhiSameAsEmergency() {
    if (!this.hasPhiContactValue) return

    const phiSameAsEmergency = this.phiSameAsEmergencyTarget.value === "true"
    this.phiSameAsEmergencyValue = phiSameAsEmergency

    if (phiSameAsEmergency) {
      this.phiContactDetailsTarget.classList.add("hidden")
      this.clearPhiFields()
    } else if (this.phiSameAsEmergencyTarget.value === "false") {
      this.phiContactDetailsTarget.classList.remove("hidden")
      this.setRequiredFields()

      const event = new Event('input', { bubbles: true })
      this.phiPhoneTarget.dispatchEvent(event)
    }
  }

  clearPhiFields() {
    this.phiFirstNameTarget.value = ""
    this.phiLastNameTarget.value = ""
    this.phiPhoneTarget.value = ""
    this.removeRequiredFields()
  }

  setRequiredFields() {
    this.phiFirstNameTarget.required = true
    this.phiLastNameTarget.required = true
    this.phiPhoneTarget.removeAttribute("disabled")
    this.phiPhoneTarget.setAttribute("required", "required")
  }

  removeRequiredFields() {
    this.phiFirstNameTarget.required = false
    this.phiLastNameTarget.required = false
    this.phiPhoneTarget.removeAttribute("required")
    this.phiPhoneTarget.setAttribute("disabled", "disabled")
  }
} 